import { trackCheckoutPurchase, getPendingCheckout } from './analytics'
import { emitUserPlanCountUpdated } from '../services/userPlanCountService'

const STORAGE_PREFIX = 'stripe_checkout_processed:'
const PAYMENT_SUCCESS_KEY = '__payment_success__'

const processedSessionKeys = new Set()
let inflightPromise = null
let inflightKey = null

function getDedupeKey(sessionId = null) {
  return sessionId || PAYMENT_SUCCESS_KEY
}

function isAlreadyProcessed(sessionId = null) {
  const key = getDedupeKey(sessionId)

  if (processedSessionKeys.has(key)) {
    return true
  }

  if (sessionId) {
    return sessionStorage.getItem(`${STORAGE_PREFIX}${sessionId}`) === '1'
  }

  return false
}

function markProcessed(sessionId = null) {
  const key = getDedupeKey(sessionId)
  processedSessionKeys.add(key)

  if (sessionId) {
    sessionStorage.setItem(`${STORAGE_PREFIX}${sessionId}`, '1')
  }
}

export function hasStripeCheckoutReturn(search = '') {
  const params = new URLSearchParams(search)
  return Boolean(params.get('session_id')) || params.get('isPaymentSuccess') === 'true'
}

export function cleanStripeCheckoutParams(search = '') {
  const params = new URLSearchParams(search)
  params.delete('session_id')
  params.delete('isPaymentSuccess')
  const nextSearch = params.toString()
  return nextSearch ? `?${nextSearch}` : ''
}

export async function completeStripeCheckoutReturn(sessionId = null) {
  const key = getDedupeKey(sessionId)

  if (isAlreadyProcessed(sessionId)) {
    return true
  }

  if (inflightPromise && inflightKey === key) {
    return inflightPromise
  }

  inflightKey = key
  inflightPromise = (async () => {
    try {
      if (isAlreadyProcessed(sessionId)) {
        return true
      }

      const pendingCheckout = getPendingCheckout()
      const saved = await trackCheckoutPurchase(sessionId || undefined)

      if (saved) {
        markProcessed(sessionId)
      }

      if (sessionId || saved) {
        emitUserPlanCountUpdated({
          retry: true,
          checkoutType: pendingCheckout?.checkoutType,
        })
      }

      return saved || Boolean(sessionId)
    } finally {
      inflightPromise = null
      inflightKey = null
    }
  })()

  return inflightPromise
}
